import { ref as h, computed as l, readonly as D, reactive as wt, getCurrentScope as Je, onScopeDispose as Tt, defineComponent as Qe, createBlock as Q, openBlock as R, Transition as Ct, withCtx as _t, createElementBlock as Ye, createCommentVNode as Y, normalizeStyle as Lt, unref as p, defineAsyncComponent as Me, toRefs as Se, watch as P, onMounted as bt, Fragment as Rt, createElementVNode as It, createVNode as Nt, withDirectives as Pe, resolveDynamicComponent as Ue, vShow as $e, createApp as Ot } from "vue";
import { CdrBreakpointMd as xt } from "@rei/cdr-tokens";
import Dt from "@rei/aria-announcer";
const Ht = (e, t) => {
  let n = null, s = null;
  return (...o) => new Promise((r, a) => {
    s && s();
    let c = !1;
    s = () => {
      c = !0, r(void 0);
    }, n && clearTimeout(n), n = setTimeout(async () => {
      try {
        s = null;
        const d = await e(...o);
        c || r(d);
      } catch (d) {
        c || a(d);
      }
    }, t);
  });
}, Mt = (e) => (e ?? "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""), Pt = (e) => e().toString(36).slice(2, 9), Te = (e, t = Math.random, n = Mt) => {
  const s = n(e), o = Pt(t);
  return `${s}-${o}`;
}, Ut = (e = document) => e.readyState === "loading";
var m = /* @__PURE__ */ ((e) => (e.None = "none", e.Autosuggest = "autosuggest", e.SearchHistory = "search history", e))(m || {}), re = /* @__PURE__ */ ((e) => (e.Control = "control", e.Variant = "variant", e))(re || {});
const y = {
  APP_MOUNT_SELECTOR: "div[data-js=search-input-suggestions]",
  SEARCH_INPUT: "input[data-js=search-field]",
  SEARCH_FORM: "form[data-js=search-form]",
  GNAV_CONTAINER: "section[data-js=gnav]",
  SEARCH_CLEAR_BTN: "button[data-js=clear-button]",
  SEARCH_SUBMIT_BTN: "button[data-js=search-button]",
  SEARCH_CANCEL_BTN: "button[data-js=search-cancel]",
  UNAV_CONTAINER: "div[data-js=unav-container]"
}, $t = "div[data-js=recent-search-box]", Ke = "#gnav-data", kt = {
  ENTER: "Enter",
  ESC: "Escape",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  HOME: "Home",
  END: "End"
}, U = {
  AUTOSUGGEST: "autosuggest-result-",
  SEARCH_HISTORY: "search-history-entry-",
  PRODUCTS: "autosuggest-product-result-"
}, ke = {
  SECTION: "data-cnstrc-item-section",
  NAME: "data-cnstrc-item-name"
}, Bt = {
  SEARCH_SUGGESTIONS: "Search Suggestions",
  PRODUCTS: "Products"
}, b = {
  KEY: "clear-all",
  TERM: "Clear all",
  DATA_UI: "clear-search-history",
  ARIA_LABEL: "Clear all recent searches",
  CLASS: "search-listbox__clear-button"
}, T = -1, qs = {
  AUTOSUGGEST: "Search Suggestions",
  SEARCH_HISTORY: "Recently searched",
  PRODUCT_SUGGESTIONS: "Product Suggestions"
}, Ws = 300, A = 0, ae = 1, Be = {
  DEFAULT_NAMESPACE: "GNavGVCSearchSIS",
  ELIGIBLE_TESTS: "data-analytics-eligible-tests"
}, J = /* @__PURE__ */ new Map(), qe = (e) => {
  const t = fn(e);
  if (!t) return {};
  const n = {
    source: "domElems.getGnavDataJson",
    selector: e
  };
  let s = pe(t, n);
  if (typeof s != "object" || s === null || Array.isArray(pe)) {
    const o = new Error("Invalid JSON structure in gnav-data script");
    w(o, n), s = {};
  }
  return s;
}, E = (e) => {
  if (J.has(e))
    return J.get(e);
  try {
    const t = document.querySelector(e);
    if (t instanceof HTMLElement)
      return J.set(e, t), t;
  } catch (t) {
    w(t, {
      source: "domElems.getDOMElem",
      selector: e
    });
  }
  return J.set(e, null), null;
}, We = (e) => {
  if (!(e instanceof Node))
    return !1;
  const t = E(y.SEARCH_INPUT), n = E(y.SEARCH_CLEAR_BTN), s = E(y.SEARCH_SUBMIT_BTN), o = E(y.SEARCH_CANCEL_BTN);
  return [
    t,
    n,
    s,
    o
  ].filter(Boolean).some((a) => a.contains(e));
}, Ft = (e) => {
  let t;
  try {
    t = document.querySelector(e);
  } catch {
  }
  return t instanceof HTMLElement;
}, Gt = (e) => {
  const t = {};
  Object.entries(e).forEach(([s, o]) => {
    t[s] = E(o);
  });
  const n = Object.entries(t).filter(([, s]) => s === null).map(([s]) => e[s]);
  if ((n == null ? void 0 : n.length) > 0) {
    const s = new Error("Autosuggest missing required DOM elements");
    return w(s, {
      source: "domElems.validateAndCacheDomElems",
      missingSelectors: n
    }), !1;
  }
  return !0;
}, Vt = (e = {}) => {
  const {
    gnavDataJsonSelector: t = Ke
  } = e, n = qe(t);
  return Jt(n), (g.shouldMountAutosuggest || g.shouldMountSearchHistory) && (n == null ? void 0 : n.searchAction) === "/search";
}, jt = () => {
  const e = E($t);
  e && (e.style.display = "none");
}, g = {
  c9rAutosuggestSectionResults: {},
  maxSearchHistoryResults: 10,
  searchPlaceholderDesktop: "",
  searchPlaceholderMobile: "",
  shouldEnableAutosuggestProducts: !1,
  shouldMountAutosuggest: !1,
  shouldMountSearchHistory: !1
};
function Jt(e) {
  const {
    /**
     * Constructor autosuggest section configuration: (constructorAutosuggestSectionResults)
     * - Originates from CCSite microservice's resources data navigation global yaml
     * - Overridden by CCSite Conman feature.toggle.override configuration by siteId
     *
     * When both sources provide configuration objects, they are merged
     * upstream before reaching this function.
     *
     * Merge behavior is:
     * - Accumulative: keys from both sources are included
     * - Overriding: when the same key exists, the override value wins
     *
     * Example:
     *   CCSite provides:
     *     { searchSuggestions: 10 }
     *
     *   feature.toggle.override provides:
     *     { products: 6, anotherKey: 10 }
     *
     *   Resulting GNAV JSON contains:
     *     { searchSuggestions: 10, products: 6, anotherKey: 10 }
     *
     * This function stores the merged result as-is and does not attempt
     * to validate or map section keys at this stage.
     */
    constructorAutosuggestSectionResults: t = {},
    disableLegacyRecentSearch: n = !1,
    enableAutosuggest: s = !1,
    enableRecentSearch: o = !1,
    recentSearchMaxSize: r = 10,
    searchPlaceholderDesktop: a = "",
    searchPlaceholderMobile: c = "",
    useConstructorAutosuggest: d = !1
  } = e;
  g.c9rAutosuggestSectionResults = t, g.maxSearchHistoryResults = r, g.searchPlaceholderDesktop = a, g.searchPlaceholderMobile = c, g.shouldEnableAutosuggestProducts = !!(t != null && t.products), g.shouldMountAutosuggest = !!s && !!d, g.shouldMountSearchHistory = !!o && n;
}
function Qt(e) {
  return g[e];
}
const Ce = "savedSearches", Yt = () => {
  const e = qe(Ke);
  let t = Number(e == null ? void 0 : e.recentSearchMaxSize);
  return (typeof t != "number" || Number.isNaN(t)) && (t = 10), t;
}, ze = () => {
  const e = { source: "searchHistory.getRawSearchHistory" }, t = on(Ce);
  if (!t) return [];
  const n = pe(t, e);
  if (typeof n != "object" || n === null || !Array.isArray(n)) {
    const s = new Error("Invalid JSON structure for search history");
    return w(s, e), [];
  }
  return n;
}, Kt = (e) => {
  const t = e.trim();
  if (!t) return;
  const s = ze().filter(
    (a) => a.searchTerm.toLowerCase() !== t.toLowerCase()
  );
  s.unshift({ searchTerm: t });
  const o = Yt(), r = s.slice(0, o);
  rn(Ce, JSON.stringify(r));
}, Xe = () => ze().map((t, n) => ({
  key: Te(t.searchTerm),
  term: t.searchTerm,
  listElementAttributes: {
    id: `${U.SEARCH_HISTORY}${n}`
  }
})), qt = () => {
  an(Ce);
}, Wt = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.listElementAttributes) == null ? void 0 : t["data-ui"]) === b.DATA_UI;
}, Fe = "Keyboard users, use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.", me = (e) => e !== 1 ? "s" : "", zt = (e) => e !== 1 ? "are" : "is", he = {
  /**
   * Message shown when no results are found for a given query.
   *
   * @param {string} query - The user's search query.
   * @returns {string} A descriptive message indicating that no results were found.
   */
  noResults: (e) => `No results found for ${e}`,
  /**
   * Message describing how many recent searches are available.
   *
   * @param {number} length - Number of items in the user's search history.
   * @returns {string} An ARIA-friendly message including navigation instructions.
   */
  searchHistory: (e) => `You have ${e} recent search result${me(e)}. ${Fe}`,
  /**
  * Builds an ARIA message describing the number of autosuggestions and optional product results
  * for a given search query.
  *
  * This message includes proper pluralization, contextual details about the results,
  * and additional guidance for keyboard and touch users.
  *
  * @param {number} suggestionCount - Total number of keyword-based suggestions.
  * @param {number} productCount - Total number of product suggestions (if enabled).
  * @param {string} query - The user's current search input.
  * @param {boolean} includeProducts - Indicates whether product suggestions
  * should be included in the message.
  *
  * @returns {string} A fully formatted ARIA message with suggestion counts, optional product counts,
  * and accessibility guidance.
  */
  autosuggest: (e, t, n) => {
    let s = `There ${zt(e)} ${e} suggestion${me(e)}`;
    return t > 0 && (s += ` and ${t} product${me(t)}`), s += ` for ${n}, including keyword matches and related results. ${Fe}`, s;
  }
}, Xt = (e) => {
  const {
    suggestionType: t,
    query: n,
    counts: s
  } = e;
  if (t === m.SearchHistory)
    return he.searchHistory(s.searchHistory ?? 0);
  if (t === m.Autosuggest) {
    const o = s.termSuggestions, r = s.products ?? 0;
    return o === 0 && r === 0 ? he.noResults(n) : he.autosuggest(
      o,
      r,
      n
    );
  }
  return "";
}, Ze = (e = {}) => Vt(e) ? Gt(y) : !1, Zt = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), en = (e) => new RegExp(`(\\b${e}\\b|${e})`, "gi"), tn = (e, t, n, s) => e.split(n).filter((r) => r && r.length > 0).map((r, a) => ({
  text: r.replace(/ /g, " "),
  // Use non-breaking spaces
  queryText: r.toLowerCase() === s,
  key: `${t}-part-${a}`
})), nn = (e, t) => {
  var a;
  const n = (a = e == null ? void 0 : e.sections) == null ? void 0 : a["Search Suggestions"];
  if (!t || !n || !Array.isArray(n))
    return [];
  const s = t.toLowerCase(), o = Zt(s), r = en(o);
  return n.map((c, d) => {
    const v = c.value, V = Te(c.data.id || v), fe = {
      id: `${U.AUTOSUGGEST}${d}`,
      [ke.SECTION]: Bt.SEARCH_SUGGESTIONS,
      [ke.NAME]: v
    }, j = tn(v, V, r, s);
    return {
      key: V,
      term: v,
      listElementAttributes: fe,
      termParts: j,
      // We can include other original data if needed
      ...c.data
    };
  });
}, sn = (e) => {
  var n;
  const t = (n = e == null ? void 0 : e.sections) == null ? void 0 : n.Products;
  return !t || !Array.isArray(t) ? [] : t.map((s) => {
    var a, c, d, v;
    const o = s.value;
    return {
      key: Te(s.data.id || o),
      name: o,
      styleId: ((a = s.data) == null ? void 0 : a.id) || "",
      brand: ((c = s.data) == null ? void 0 : c.brand) || "",
      url: ((d = s.data) == null ? void 0 : d.url) || "",
      imageUrl: ((v = s.data) == null ? void 0 : v.image_url) || ""
    };
  });
}, _e = () => window.localStorage ? window.localStorage : null, Le = (e, t) => {
  console.error(`[localStorage] Unavailable when calling ${e}("${t}")`);
}, on = (e) => {
  const t = _e();
  if (!t)
    return Le("getLocalStorageByKey", e), null;
  try {
    return t.getItem(e);
  } catch (n) {
    return console.error(`[localStorage] getItem failed for "${e}":`, n), null;
  }
}, rn = (e, t) => {
  const n = _e();
  if (!n) {
    Le("setLocalStorageByKey", e);
    return;
  }
  try {
    n.setItem(e, t);
  } catch (s) {
    console.error(`[localStorage] setItem failed for "${e}":`, s);
  }
}, an = (e) => {
  const t = _e();
  if (!t) {
    Le("removeLocalStorageByKey", e);
    return;
  }
  try {
    t.removeItem(e);
  } catch (n) {
    console.error(`[localStorage] removeItem failed for "${e}":`, n);
  }
}, cn = (e, t) => {
  var o, r;
  const n = (r = (o = window == null ? void 0 : window.document) == null ? void 0 : o.location) == null ? void 0 : r.hostname;
  if (!(n == null ? void 0 : n.includes("www.rei.com"))) {
    const a = {
      component: "SearchInputSuggestions",
      vendor: "C9r",
      ...t
    }, c = "color: red;";
    console.group("%cError in Search Input Suggestions", c), console.log(`%cMessage: ${e.message}`, c), console.log("%cContext:", c), console.dir(a), console.groupEnd();
  }
}, un = (e = 5e3, t = 500) => new Promise((n, s) => {
  let o = 0;
  const r = Math.ceil(e / t), a = () => {
    var c;
    typeof ((c = window == null ? void 0 : window.DD_RUM) == null ? void 0 : c.addError) == "function" ? n(window.DD_RUM) : (o += 1, o >= r ? s(new Error(`DD_RUM not available after ${r} attempts`)) : setTimeout(a, t));
  };
  a();
}), ln = (e, t) => (n, s) => {
  const o = {
    component: "SearchInputSuggestions",
    vendor: "C9r",
    ...s
  };
  return t().then((r) => {
    try {
      r == null || r.addError(n, o);
    } catch (a) {
      const c = {
        ...o,
        ddRumFailure: !0,
        ddRumErrMsg: (a == null ? void 0 : a.message) ?? "Unknown DD_RUM runtime error"
      };
      e(n, c);
    }
  }).catch((r) => {
    const a = {
      ...o,
      ddRumFailure: !0,
      ddRumErrMsg: (r == null ? void 0 : r.message) ?? "Unknown DD_RUM init error"
    };
    e(n, a);
  });
}, dn = window.location.hostname.includes("localhost"), gn = dn ? () => Promise.reject(new Error("Local dev: Skipping DD_RUM wait")) : un, w = ln(cn, gn), fn = (e) => {
  if (!e) return null;
  let t;
  try {
    t = document.querySelector(e);
  } catch {
    return null;
  }
  return !t || !(t instanceof HTMLScriptElement) || t.getAttribute("type") !== "application/json" ? null : t.textContent;
}, pe = (e, t = {}) => {
  if (e === null) return null;
  const n = { ...t, jsonTextContent: e };
  try {
    const s = JSON.parse(e.trim());
    if (typeof s != "object" || s === null) {
      const o = new Error("Invalid JSON structure in the script");
      return w(o, n), null;
    }
    return s;
  } catch (s) {
    const o = new Error(`Failed to parse JSON from script tag. Original error: ${s == null ? void 0 : s.message}`);
    return w(o, n), null;
  }
}, Sn = (e) => {
  const {
    message: t,
    stack: n,
    name: s
  } = e;
  return {
    message: t,
    stack: n,
    name: s
  };
}, ve = (e) => {
  const {
    tagName: t,
    classList: n,
    id: s,
    outerHTML: o
  } = e;
  return {
    tagName: t,
    classList: Array.from(n || []),
    attributes: e.getAttributeNames(),
    id: s,
    outerHTML: o == null ? void 0 : o.slice(0, 200)
  };
}, mn = (e) => {
  if (!e || !(e instanceof Element)) return {};
  const {
    firstElementChild: t,
    lastElementChild: n
  } = e, s = (o) => o && o instanceof Element;
  return {
    self: ve(e),
    firstChild: s(t) ? ve(t) : {},
    lastChild: s(n) ? ve(n) : {}
  };
}, hn = (e) => {
  if (!e || !e.$options)
    return {
      componentName: "not found, invalid vm",
      elDetails: {}
    };
  const {
    $options: t,
    $el: n,
    $data: s,
    $props: o
  } = e, {
    name: r,
    __file: a
  } = t;
  return {
    componentName: r,
    fileSource: a,
    props: o,
    data: s,
    elDetails: mn(n)
  };
}, vn = (e, t, n) => {
  if (!(e instanceof Error)) return;
  const s = {
    source: "Vue Internal Error",
    info: n,
    errorDetails: Sn(e),
    vmDetails: hn(t)
  };
  w(e, s);
}, En = (e, t = {}) => ({
  handler: typeof t[e.key] == "function" ? t[e.key] : () => {
  }
});
function pn(e, t) {
  return typeof e == "object" && e !== null && typeof e.experimentName == "string" && e.experimentName.trim() !== "" && t.trim() !== "" && e.experimentName === t;
}
function An(e, t) {
  return (Array.isArray(e) ? e : [e]).filter((s) => s.action === "setJson").flatMap((s) => Array.isArray(s.content) ? s.content : []).flatMap((s) => Array.isArray(s) ? s : [s]).find((s) => pn(s, t));
}
function yn(e, t) {
  function n(o) {
    return (o == null ? void 0 : o.experience) && Object.values(re).includes(o.experience);
  }
  const s = (o, r = null) => {
    const a = r || "Adobe Target getOffer API failed.", c = new Error(`${a} Original error: ${o == null ? void 0 : o.message}`);
    return w(c, {
      source: "adobeTarget.getJsonOfferExperience",
      mbox: e,
      experimentName: t
    }), c;
  };
  return new Promise((o) => {
    var r, a;
    if (typeof window > "u" || !((r = window.adobe) != null && r.target)) {
      const c = new Error("Undefined adobe.target window API");
      s(c), o(null);
      return;
    }
    try {
      (a = window.adobe.target) == null || a.getOffer({
        mbox: e,
        params: {},
        // timeout removed to rely on Adobe Target default (≈2s)
        success: (c) => {
          const d = An(
            c,
            t
          );
          if (n(d))
            o(d);
          else {
            const v = new Error("Unexpected Adobe Target API response");
            s(v), o(null);
          }
        },
        error: (c) => {
          s(c, "Adobe Target getOffer call failed."), o(null);
        }
      });
    } catch (c) {
      s(c), o(null);
    }
  });
}
const wn = "event1", Tn = {
  productClick: "searchbox-_-product-_-autosuggest"
};
function Cn(e) {
  if (!(typeof window > "u"))
    try {
      if (!window.metrics || typeof window.metrics.link != "function") {
        w(
          new Error("window.metrics.link is unavailable"),
          {
            source: "searchAnalytics.window.metrics.link",
            hasMetrics: !!window.metrics
          }
        );
        return;
      }
      window.metrics.link(e);
    } catch (t) {
      w(
        t instanceof Error ? t : new Error("Unknown metrics.link error"),
        {
          source: "searchAnalytics.window.metrics.link",
          payload: e
        }
      );
    }
}
function _n(e) {
  const {
    typedQuery: t,
    position: n,
    styleId: s,
    eventId: o,
    linkName: r
  } = e;
  return {
    events: o ?? wn,
    linkName: r ?? `${Tn.productClick}_${s}`,
    searchTermClicked: t,
    searchTermType: "autosuggest",
    autoSuggestPosition: String(n),
    products: `;${s};;;;`
  };
}
function Ln(e) {
  var s;
  const { typedQuery: t } = e;
  if (!t) return;
  const n = _n(e);
  ((s = document == null ? void 0 : document.location) == null ? void 0 : s.hostname) !== "www.rei.com" && (console.group("SIS Autosuggest Product Metrics"), Object.entries(n).forEach(([o, r]) => console.log(`${o}:`, r)), console.groupEnd()), Cn(n);
}
const H = h(""), ce = h(!1), et = l(() => H.value.trim()), tt = l(() => !!et.value), nt = "search__input--has-clear";
let i = null, q = !1;
function bn(e, t = lt) {
  En(e, t).handler(e);
}
function st(e) {
  bn(e, lt);
}
function Rn() {
  i && i.classList.toggle(
    nt,
    tt.value
  );
}
function ot() {
  Vn.isFormSubmitting || St(), setTimeout(() => {
    ys(), Ls(), H.value = i.value, ce.value = !0;
  }, 100);
}
function rt() {
  i && (i.value = "", H.value = "", i.setAttribute("aria-activedescendant", ""), i.setAttribute("aria-expanded", "false"));
}
function at() {
  St(), H.value = i.value;
}
function In(e) {
  if (!i) return;
  const { experimentName: t, scope: n, team: s } = e, r = `${n || s || Be.DEFAULT_NAMESPACE}_${t}`;
  i.setAttribute(
    Be.ELIGIBLE_TESTS,
    r
  );
}
function W(e) {
  i.contains(e.target) || (ce.value = !1, Ae(T));
}
function Nn(e, t) {
  if (q) return;
  const n = y.SEARCH_INPUT;
  i = E(n), e && In(e), i.addEventListener("focus", ot), i.addEventListener("keydown", st), i.addEventListener("input", at), window.addEventListener("focusin", W), window.addEventListener("mousedown", W), q = !0;
}
function On() {
  q && (i.removeEventListener("focus", ot), i.removeEventListener("keydown", st), i.removeEventListener("input", at), i.classList.remove(nt), window.removeEventListener("focusin", W), window.removeEventListener("mousedown", W), H.value = "", ce.value = !1, i = null, q = !1);
}
function xn(e) {
  i.setAttribute("aria-expanded", String(e));
}
function Dn(e) {
  i.value = e, H.value = e;
}
function Hn(e) {
  const { searchPlaceholderDesktop: t, searchPlaceholderMobile: n } = g, s = e ? n : t;
  i.placeholder = s;
}
function Mn(e, t = A) {
  if (e < 0) {
    i.setAttribute("aria-activedescendant", "");
    return;
  }
  let n = "";
  switch (L.currentSuggestionType) {
    case m.SearchHistory:
      n = U.SEARCH_HISTORY;
      break;
    case m.Autosuggest:
      t === A ? n = U.AUTOSUGGEST : t === ae && (n = U.PRODUCTS);
      break;
  }
  i.setAttribute(
    "aria-activedescendant",
    n ? `${n}${e}` : ""
  );
}
const _ = D({
  inputFieldIsFocused: ce,
  cleanQuery: et,
  isValidQuery: tt
}), { SEARCH_FORM: Pn, SEARCH_CANCEL_BTN: Un, SEARCH_CLEAR_BTN: $n } = y;
let O, z, I, X = !1;
const be = h(!1);
function ct() {
  Kt(_.cleanQuery);
}
const kn = () => {
  I && (I.setAttribute("aria-hidden", "true"), I.setAttribute("data-visible", "hidden"), I.setAttribute("style", "margin-right: 0;"));
};
function it() {
  vt(), rt(), kn(), Oe();
}
function Bn() {
  X || (O = E(Pn), z = E(Un), I = E($n), O.addEventListener("submit", ct), z.addEventListener("click", it), be.value = !1, X = !0);
}
function Fn() {
  X && (O.removeEventListener("submit", ct), z.removeEventListener("click", it), O = null, z = null, I = null, X = !1);
}
function Gn(e) {
  if (!e) return;
  ft(), be.value = !0, Dn(e), O.dispatchEvent(new Event("submit"));
  const t = new CustomEvent(
    "termSelected",
    {
      bubbles: !0,
      cancelable: !0
    }
  );
  O.dispatchEvent(t);
}
const Vn = D({
  isFormSubmitting: be
}), Ee = [
  A,
  ae
], {
  ENTER: jn,
  ESC: Jn,
  ARROW_UP: Qn,
  ARROW_DOWN: Yn,
  ARROW_LEFT: Kn,
  ARROW_RIGHT: qn,
  HOME: Wn,
  END: zn
} = kt, ie = l(() => {
  const e = {
    [A]: L.currentTermSuggestionsLength
  };
  if (L.currentSuggestionType !== m.SearchHistory) {
    const t = we.isCdrMdMqDown ? 3 : L.autosuggestProductSuggestionsLength;
    e[ae] = t;
  }
  return e;
}), ut = l(
  () => Object.values(ie.value).some((e) => e > 0)
), S = h(T), f = h(A);
function Z(e) {
  const t = ie.value, n = Ee.length, s = Ee.indexOf(f.value);
  for (let o = 1; o <= n; o += 1) {
    const r = (s + e * o + n) % n, a = Ee[r];
    if (t[a] > 0)
      return a;
  }
  return f.value;
}
function Xn(e) {
  if (e.preventDefault(), !ut.value) return;
  const n = ie.value[f.value];
  if (n === 0) {
    const o = Z(1);
    f.value = o, S.value = 0;
    return;
  }
  if (S.value >= n - 1) {
    const o = Z(1);
    f.value = o, S.value = 0;
  } else
    S.value += 1;
}
function Zn(e) {
  if (e.preventDefault(), !ut.value) return;
  const t = ie.value;
  if (t[f.value] === 0) {
    const o = Z(-1);
    f.value = o, S.value = t[o] - 1;
    return;
  }
  if (S.value <= 0) {
    const o = Z(-1);
    f.value = o, S.value = t[o] - 1;
  } else
    S.value -= 1;
}
function es() {
  S.value = T, f.value = A;
}
function ts() {
  S.value = T, f.value = A;
}
function ns(e) {
  e.preventDefault(), S.value = T, f.value = A;
}
function ss(e) {
  e.preventDefault(), S.value = T, f.value = A;
}
function os(e, t) {
  var o;
  const n = L.currentTermSuggestions[e], s = (o = n == null ? void 0 : n.term) == null ? void 0 : o.trim();
  if (s) {
    if (Wt(n)) {
      ps();
      return;
    }
    Gn(s), (t == null ? void 0 : t.target) instanceof HTMLElement && t.target.blur();
  }
}
function rs(e) {
  const t = S.value;
  t !== T && e.preventDefault(), f.value === A ? os(t, e) : f.value === ae && bs(t);
}
function as() {
  rt(), ft();
}
const lt = {
  [jn]: rs,
  [Jn]: as,
  [Qn]: Zn,
  [Yn]: Xn,
  [Kn]: es,
  [qn]: ts,
  [Wn]: ns,
  [zn]: ss
};
function Ae(e, t = A) {
  S.value = e, f.value = t;
}
function cs() {
  S.value = T, f.value = A;
}
const is = D({
  listboxActiveItemIndex: S,
  listboxActiveSectionIndex: f
}), C = h([]), us = l(
  () => C.value.length > 0
), dt = l(() => {
  const e = C.value.length, t = {
    key: b.KEY,
    term: b.TERM,
    listElementAttributes: {
      id: `search-history-entry-${e}`,
      "aria-label": b.ARIA_LABEL,
      "data-ui": b.DATA_UI,
      class: b.CLASS
    }
  };
  return [...C.value, t];
}), G = h(!1), ue = h({}), le = l(
  () => nn(ue.value, _.cleanQuery)
), de = l(
  () => sn(ue.value)
), ls = l(
  () => le.value.length > 0 || de.value.length > 0
), ds = l(
  () => le.value.length || g.c9rAutosuggestSectionResults.searchSuggestions
), gs = l(
  () => de.value.length || g.c9rAutosuggestSectionResults.products
), $ = h(!1), ee = l(() => $.value || !_.inputFieldIsFocused ? m.None : _.isValidQuery && ls.value || G.value ? m.Autosuggest : !_.cleanQuery && us.value ? m.SearchHistory : m.None), fs = l(
  () => ee.value !== m.None
), gt = l(() => ee.value === m.Autosuggest ? le.value : ee.value === m.SearchHistory ? dt.value : []), Ss = l(
  () => {
    var e;
    return ((e = gt.value) == null ? void 0 : e.length) || 0;
  }
), ms = l(
  () => {
    var e;
    return ((e = de.value) == null ? void 0 : e.length) || 0;
  }
), hs = l(
  () => C.value.length || 0
);
function zs(e) {
  ue.value = e;
}
function ft() {
  $.value = !0;
}
function St() {
  $.value && ($.value = !1);
}
function Xs() {
  G.value = !0;
}
function Zs() {
  G.value = !1;
}
function mt(e) {
  e.persisted && (C.value = Xe());
}
let te = !1;
function vs() {
  te || (g.shouldMountSearchHistory && (jt(), C.value = Xe()), window.addEventListener("pageshow", mt), te = !0);
}
function Es() {
  te && (C.value = [], window.removeEventListener("pageshow", mt), ue.value = {}, $.value = !1, G.value = !1, te = !1);
}
function ps() {
  qt(), C.value = [];
}
const L = D({
  autosuggestSearchSuggestions: le,
  autosuggestProductSuggestions: de,
  rawSearchHistorySuggestions: C,
  searchHistoryListboxSuggestions: dt,
  currentSuggestionType: ee,
  currentTermSuggestions: gt,
  currentTermSuggestionsLength: Ss,
  rawSearchHistorySuggestionsLength: hs,
  autosuggestProductSuggestionsLength: ms,
  areSuggestionsDisplayed: fs,
  isAutosuggestLoading: G,
  previousAutosuggestSearchSuggestionsLength: ds,
  previousAutosuggestProductSuggestionsLength: gs
}), Re = "search-site-page-overlay-no-scroll", ge = h(!1), Ie = h(0);
let Ne = null, N = null;
function As(e) {
  Ne = e;
}
function Ge() {
  const { bottom: e } = Ne.getBoundingClientRect();
  Ie.value = window.scrollY + e;
}
function ys() {
  window.scrollTo(0, 0), document.body.classList.add(Re), ge.value = !0;
}
function Oe() {
  document.body.classList.remove(Re), ge.value = !1;
}
function ne(e) {
  We(e.target) || Oe();
}
function ws(e = y.GNAV_CONTAINER) {
  const t = E(e);
  As(t), Ge(), N = new ResizeObserver(() => {
    Ge();
  }), N.observe(t), window.addEventListener("focusin", ne), window.addEventListener("mousedown", ne);
}
function Ts() {
  document.body.classList.remove(Re), ge.value = !1, Ie.value = 0, Ne = null, N == null || N.disconnect(), N = null, window.removeEventListener("focusin", ne), window.removeEventListener("mousedown", ne);
}
const Ve = D({
  isSearchSitePageOverlayActive: ge,
  navHeight: Ie
}), ht = h(null), se = h(!1), x = "autosuggest-products-layout";
let k = null, B = null;
function Cs(e) {
  k = e;
}
function _s(e) {
  B = e;
}
function Ls() {
  se.value && (k.classList.add(x), B.classList.add(x));
}
function vt() {
  k.classList.remove(x), B.classList.remove(x);
}
function bs(e) {
  const { url: t, styleId: n } = L.autosuggestProductSuggestions[e];
  t && (Ln({
    typedQuery: _.cleanQuery,
    position: e,
    styleId: n
  }), window.location.href = t);
}
function oe(e) {
  We(e.target) || vt();
}
function Rs(e = null, t = y.GNAV_CONTAINER, n = y.UNAV_CONTAINER) {
  const s = E(t), o = E(n), {
    experience: r,
    c9rAutosuggestSectionResults: a
  } = e || {}, c = r === re.Variant, v = Qt("shouldEnableAutosuggestProducts") || c;
  s && o && v && (a && (ht.value = a), se.value = !0, Cs(s), _s(o), window.addEventListener("focusin", oe), window.addEventListener("mousedown", oe));
}
function Is() {
  se.value && (k.classList.remove(x), B.classList.remove(x), k = null, B = null, ht.value = null, se.value = !1, window.removeEventListener("focusin", oe), window.removeEventListener("mousedown", oe));
}
const Ns = {
  isCdrMdMqDown: `(max-width: calc(${xt}px - 1px))`
}, F = wt({}), K = {}, ye = {};
function Os() {
  typeof window > "u" || Object.entries(Ns).forEach(([e, t]) => {
    const n = window.matchMedia(t);
    F[e] = n.matches;
    const s = (o) => {
      F[e] = o.matches;
    };
    ye[e] = s, n.addEventListener("change", s), K[e] = n;
  });
}
function xs() {
  Object.keys(K).forEach((e) => {
    K[e].removeEventListener("change", ye[e]), delete K[e], delete ye[e];
  }), Object.keys(F).forEach((e) => {
    delete F[e];
  });
}
const we = D(F);
function Ds() {
  On(), Fn(), cs(), Es(), Ts(), Is(), xs();
}
function Hs(e) {
  const t = e || Je();
  if (!t) {
    const s = `Failed to register teardown of stores. ${[
      "registerTeardownStores() must be called",
      "within setup(), a lifecycle hook (sync thread), or given an explicit EffectScope."
    ].join(" ")}`;
    throw new Error(s);
  }
  t.run(() => {
    Tt(Ds);
  });
}
function Ms(e) {
  const { abTestExperienceContent: t, appEffectScope: n } = e || {};
  ws(), Rs(t), Nn(t), Bn(), Os(), vs(), Hs(n);
}
const Ps = /* @__PURE__ */ Qe({
  __name: "SearchSitePageOverlay",
  setup(e) {
    const t = l(() => Ve.isSearchSitePageOverlayActive), n = () => Oe();
    return (s, o) => (R(), Q(Ct, {
      name: "search-site-page-overlay-fade"
    }, {
      default: _t(() => [t.value ? (R(), Ye("div", {
        key: 0,
        class: "search-site-page-overlay",
        "data-js": "search-site-page-overlay",
        style: Lt({
          top: `${p(Ve).navHeight}px`
        }),
        onClick: n
      }, null, 4)) : Y("", !0)]),
      _: 1
    }));
  }
}), Us = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, o] of t)
    n[s] = o;
  return n;
}, $s = /* @__PURE__ */ Us(Ps, [["__scopeId", "data-v-3b35ba7b"]]), ks = {
  class: "search-input-suggestions"
}, je = 3, Bs = "search-input-products-in-autosuggest", Fs = "Products in Autosuggest Test SE-3313", Gs = /* @__PURE__ */ Qe({
  __name: "SearchInputSuggestions",
  setup(e) {
    const t = Me(() => import("./SearchAutosuggest-CQFPK1DF.mjs")), n = Me(() => import("./SearchHistory-C1pKYgOU.mjs")), {
      currentSuggestionType: s,
      currentTermSuggestionsLength: o,
      autosuggestProductSuggestionsLength: r,
      areSuggestionsDisplayed: a,
      rawSearchHistorySuggestionsLength: c
    } = Se(L), {
      listboxActiveItemIndex: d,
      listboxActiveSectionIndex: v
    } = Se(is), {
      cleanQuery: V,
      isValidQuery: fe
    } = Se(_), j = h(""), At = Ht(Xt, 1e3);
    P(a, (u) => {
      xn(u), Ae(T);
    });
    const xe = l(() => {
      const u = r.value;
      return we.isCdrMdMqDown && u > je ? je : u;
    });
    P([o, xe, c], async () => {
      Ae(T), j.value = await At({
        suggestionType: s.value,
        query: V.value,
        counts: {
          termSuggestions: o.value,
          products: xe.value,
          searchHistory: c.value
        }
      });
    }), P(fe, () => {
      Rn();
    }), P([d, v], () => {
      Mn(d.value, v.value);
    }), P(we, ({
      isCdrMdMqDown: u
    }) => {
      Hn(u);
    });
    function yt(u) {
      return Object.values(re).includes(u == null ? void 0 : u.experience) && typeof (u == null ? void 0 : u.experimentName) == "string" && (u == null ? void 0 : u.experimentName.length) > 0;
    }
    const M = h(null);
    return bt(async () => {
      const u = Je(), De = await yn(Bs, Fs);
      M.value = De;
      const He = {
        appEffectScope: u
      };
      yt(M == null ? void 0 : M.value) && (He.abTestExperienceContent = M.value), Ms(He);
    }), (u, De) => (R(), Ye(Rt, null, [It("div", ks, [p(g).shouldMountAutosuggest ? Pe((R(), Q(Ue(p(t)), {
      key: 0
    }, null, 512)), [[$e, p(s) === p(m).Autosuggest]]) : Y("", !0), p(g).shouldMountSearchHistory ? Pe((R(), Q(Ue(p(n)), {
      key: 1
    }, null, 512)), [[$e, p(s) === p(m).SearchHistory]]) : Y("", !0), p(g).shouldMountAutosuggest || p(g).shouldMountSearchHistory ? (R(), Q(p(Dt), {
      key: 2,
      id: "gnav-search-status",
      message: j.value,
      class: "search-input-suggestions__aria-announcer"
    }, null, 8, ["message"])) : Y("", !0)]), Nt(p($s))], 64));
  }
}), { APP_MOUNT_SELECTOR: Et } = y, pt = (e, t) => {
  const n = new Error(e);
  w(n, t);
};
var Vs = /* @__PURE__ */ ((e) => (e.mount = "Failed Vue createApp and mount", e.mountDomTarget = "Missing Vue app mount rootContainer DOM target", e))(Vs || {});
const js = (e) => {
  if (Ze(e)) {
    const t = E(Et);
    try {
      const n = Ot(Gs);
      n.config.errorHandler = vn, n.mount(t);
    } catch (n) {
      pt("Failed Vue createApp and mount", { cause: n.message, source: "initSearch" });
    }
  }
}, Js = (e, t = !1) => {
  const n = "DOMContentLoaded";
  if (Ft(Et))
    js(e);
  else if (Ut() && !t)
    document.addEventListener(
      n,
      () => Js(e, !0),
      { once: !0 }
    );
  else if (Ze(e)) {
    const o = `initSearchWithDomLoadGuard${t ? ` from ${n}` : ""}`;
    pt("Missing Vue app mount rootContainer DOM target", { source: o });
  }
};
export {
  U as A,
  Bt as D,
  qs as L,
  Vs as M,
  ae as S,
  ht as a,
  is as b,
  L as c,
  Ht as d,
  Ve as e,
  se as f,
  g,
  bs as h,
  _ as i,
  Xs as j,
  Ws as k,
  w as l,
  Zs as m,
  m as n,
  Wt as o,
  ps as p,
  A as q,
  Ae as r,
  zs as s,
  Js as t,
  Gn as u
};
